<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Despachos</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <inertia-link class="btn-indigo" :href="route('despachos.create')">
        <span>Agregar</span>
        <span class="hidden md:inline">Despacho</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Operador</th>
          <th class="px-6 pt-6 pb-4">Placas</th>
          <th class="px-6 pt-6 pb-4">Maquinaria</th>
          <th class="px-6 pt-6 pb-4">Total</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Observaciones</th>
        </tr>
        <tr v-for="despacho in despachos.data" :key="despacho.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('despachos.edit', despacho.id)" tabindex="-1">
              {{ despacho.operador }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('despachos.edit', despacho.id)">
              {{ despacho.placas }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('despachos.edit', despacho.id)" tabindex="-1">
                {{ despacho.clase }}
            </inertia-link>
          </td>
           <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('despachos.edit', despacho.id)" tabindex="-1">
                {{ despacho.total }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('despachos.edit', despacho.id)" tabindex="-1">
                {{ despacho.observaciones }}
            </inertia-link>
          </td>
        </tr>
        <tr v-if="despachos.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No Encontramos Depachos</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="despachos.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'Despachos' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    despachos: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('despachos'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
